module.exports = __webpack_public_path__ + "img/randomizer.895fbaf8.png";